import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledLink, StyledText } = Styles;

export const Link = ({ border, small, large, weight, children, wrapper: Wrapper, ...otherProps }) =>
    Wrapper ? (
        <StyledLink>
            <Wrapper {...otherProps}>
                <StyledText border={border} small={small} large={large} weight={weight}>
                    {children}
                </StyledText>
            </Wrapper>
        </StyledLink>
    ) : (
        <StyledLink>
            <a {...otherProps}>
                <StyledText border={border} small={small} large={large} weight={weight}>
                    {children}
                </StyledText>
            </a>
        </StyledLink>
    );

Link.propTypes = {
    large: PropTypes.bool,
    small: PropTypes.bool,
    border: PropTypes.bool,
    weight: PropTypes.oneOf(['light', 'regular', 'medium', 'semiBold', 'bold']),
    children: PropTypes.node.isRequired,
    wrapper: PropTypes.shape({}),
};

Link.defaultProps = { large: false, small: false, border: true, weight: 'regular', wrapper: null };

Link.Styles = Styles;
